import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TendersListComponent } from './_components/tenders-list/tenders-list.component';
import { TendersListingResolver } from 'src/app/_utils/_resolvers/tenders-listing.resolver';

import { TendersResolver } from 'src/app/_utils/_resolvers/main-data.resolver';

const routes: Routes = [
    {
        path: '',
        component: TendersListComponent,
        resolve: { tendersListResolver: TendersListingResolver, tendersResolver: TendersResolver }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TendersListRoutingModule { }